import { differenceInDays } from 'date-fns'

import { BookingDTO } from '@/clients/booking'

import { DetailedShipmentRequiredAction } from '../domain/detailed-shipment'
import { RequiredAction, RequiredActionSchema, RequiredActionSearchLocation } from '../domain/requiredAction'

export const shipmentRequiredActionsMapper = (
  requiredAction: DetailedShipmentRequiredAction & {
    origin?: RequiredActionSearchLocation
    destination?: RequiredActionSearchLocation
  }
): RequiredAction => {
  return RequiredActionSchema.parse({
    id: requiredAction._id,
    //   requiredActionTemplateId: requiredAction.requiredActionTemplateId,
    entityType: 'shipment',
    entityId: requiredAction.shipmentId,
    active: requiredAction.active,
    category: requiredAction.category,
    completed: requiredAction.completed,
    completedBy: requiredAction.completedBy,
    customerReferenceDate: {
      reference: requiredAction.customerReferenceDate.reference,
      daysFromReference: requiredAction.customerReferenceDate.daysFromReference,
    },
    description: requiredAction.description,
    hiddenFromCustomer: requiredAction.hiddenFromCustomer,
    //   opsReferenceDate: {
    //     reference: requiredAction.opsReferenceDate.reference,
    //     daysFromReference: requiredAction.opsReferenceDate.daysFromReference,
    //   },
    //   relevant: requiredAction.relevant,
    //   startShowReferenceDate: {
    //     reference: requiredAction.startShowReferenceDate.reference,
    //     daysFromReference: requiredAction.startShowReferenceDate.daysFromReference,
    //   },
    type: requiredAction.type,
    customerDueDate: requiredAction.customerDueDate,
    critical: requiredAction.customerDueDate && differenceInDays(requiredAction.customerDueDate, new Date()) < 1,
    //   opsDueDate: requiredAction.opsDueDate,
    //   startShowDate: requiredAction.startShowDate,
    // customerId: requiredAction.customer_id,
    origin: requiredAction.origin,
    destination: requiredAction.destination,
  })
}

export const bookingRequiredActionsMapper = (booking: BookingDTO): RequiredAction => {
  return RequiredActionSchema.parse({
    id: booking.id,
    entityType: 'booking',
    entityId: booking.id,
    active: true,
    category: 'authorize',
    completed: false,
    completedBy: null,
    customerReferenceDate: {
      reference: 'bookingDate',
      daysFromReference: 0,
    },
    description: 'Authorize or reject the booking',
    hiddenFromCustomer: false,
    i18n: {
      term: 'action-item-authorize-booking',
      params: {},
    },
    type: 'authorizeBooking',
    customerDueDate: null,
    critical: true,
    origin: {
      address: null,
      port: { name: booking.originPortName },
    },
    destination: {
      address: null,
      port: { name: booking.destinationPortName },
    },
  })
}
